module.exports = __webpack_public_path__ + "img/Vector_2.e09b79dc.svg";